<template>
  <div id="battleApp">
    <el-form size="mini" v-model="fromLevel">
      <el-form-item label="等级">
        <el-input placeholder="起始等级" size="mini" style="width: 88px;" v-model="fromLevel.fromPoint"></el-input>
        -
        <el-input placeholder="结束等级" size="mini" style="width:88px;" v-model="fromLevel.toPoint"></el-input>
        <span style="padding-left: 10px;">
          <label style="padding-right: 10px;" >报价文本包含预计时间</label>
          <el-switch
            v-model="fromLevel.showTime"
          >
          </el-switch>
        </span>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: 'Level',
    data () {
      return {
        gameId: 51,
        fromLevel: {
          fromPoint: '',
          toPoint: '',
          showTime: true,
          inscriptionId: 0,
        }
      }
    },
    mounted () {
    },
    methods: {
    }
  }
</script>

<style scoped>

</style>
